module.exports = __webpack_public_path__ + "img/p1.15469bf4.png";